import React from 'react';
import { atom } from '@reatom/framework';

import { getComponentDebugName } from '@/js/libs/reatom-devtools/index.ts';

import type { Context } from './context.ts';
import { createSpyContext } from './context.ts';
import type { Observable } from './observable.ts';
import { createObservableFromAtom } from './observable.ts';

export function useMapped$<T>(map: (ctx: Context) => T): Observable<T> {
  return React.useMemo(
    () => createObservableFromAtom(atom((ctx) => map(createSpyContext(ctx)), getComponentDebugName('useMapped$'))),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
}
